//---------------------------------------------------------
// Soft #40: OAM chart proxy caller. GET /api/oam/loxilbs/:id/metrics/charts/:name
// for the dashboard's selected instance, with the existing login header
// (GET_OAM). No query string is ever sent.
//---------------------------------------------------------
import {GET_OAM} from '../fetcher/fetcher_oam';
import {IMetricsChartResult, METRICS_CHART_NAMES, MetricsChartError, MetricsChartErrorCode, MetricsChartName} from 'types/metricsCharts';

const KNOWN_CODES: MetricsChartErrorCode[] = ['METRICS_NOT_CONFIGURED', 'METRICS_UNAVAILABLE', 'METRICS_BAD_RESPONSE', 'BACKENDS_UNAVAILABLE', 'INSTANCE_LOOKUP_UNAVAILABLE', 'NOT_FOUND'];

export function metricsChartPath(instanceId: number, name: MetricsChartName): string {
	if (!Number.isInteger(instanceId) || instanceId <= 0) throw new Error(`bad instance id: ${instanceId}`);
	if (!(METRICS_CHART_NAMES as readonly string[]).includes(name)) throw new Error(`unknown chart: ${name}`);
	return `/loxilbs/${instanceId}/metrics/charts/${name}`;
}

export async function fetchMetricsChart(instanceId: number, name: MetricsChartName, range?: string): Promise<IMetricsChartResult> {
	const path = range ? `${metricsChartPath(instanceId, name)}?range=${encodeURIComponent(range)}` : metricsChartPath(instanceId, name);
	const resp = await GET_OAM<IMetricsChartResult>(path);
	if (resp.code === 200 && resp.data && Array.isArray(resp.data.series)) return resp.data;
	const err = (resp.data as unknown as {error?: {code?: string; message?: string}} | null)?.error;
	const code = (KNOWN_CODES as string[]).includes(err?.code ?? '') ? (err!.code as MetricsChartErrorCode) : 'UNKNOWN';
	throw new MetricsChartError(resp.code, code, err?.message || resp.message || 'chart request failed');
}
